// Report ids that make up the "Learning Insights" category (the Early Access reports).
export const INSIGHT_REPORT_IDS = [67, 68, 69, 70, 71, 72, 73, 74];

export const isInsightReport = (reportId?: number): boolean => reportId !== undefined && INSIGHT_REPORT_IDS.includes(reportId);
